import { makeStyles } from '@material-ui/core'
import checkImage from '../../../../../assets/svg/check.svg'
import searchImage from '../../../../../assets/svg/search.svg'

export const useStyles = makeStyles((theme) => ({
  propertiesContainer: {
    height: '100%',
    position: 'relative',
    color: theme.app.colors.text.primary
  },

  infoCobertura: {
    display: 'block',
    fontSize: 14,
    marginBottom: 8
  },

  containerCheckbox: {
    display: 'flex',
    gap: 16,
    marginBottom: 16,

    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'center',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',

      alignItems: 'flex-start',
      gap: 10
    }
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  },

  infoCoberturaError: {
    display: 'block',
    color: theme.app.indication.danger,
    fontSize: theme.app.typography.error.fontSize,
    marginBottom: theme.app.spacing.sm
  },

  propertiesDivider: {
    width: '100%'
  },

  propertiesHeader: {
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      display: 'inline-flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },

  propertiesTitle: {
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.subTitle.fontSize,
    fontWeight: theme.app.typography.subTitle.fontWeight,
    '& a': {
      color: theme.palette.primary.main,
      textDecoration: 'none'
    }
  },

  propertiesButtonContainer: {
    marginLeft: 'auto',
    width: '100%',
    '& h1': {
      margin: '0 16px 0 0',
      cursor: 'pointer'
    },
    '@media (min-width:356px)': {
      width: 'unset',
      '& button': {
        width: 146,
        margin: '0 16px 0 0',
        '& img': {
          marginRight: 8
        }
      }
    }
  },

  propertiesPopup: {
    '& .popup__box': {
      height: 'auto'
    }
  },

  customButtonWrapper: {
    width: 'auto'
  },

  buttonContainer: {
    display: 'flex',
    gap: '10px',
    marginBottom: '-2px',
    paddingLeft: '10px',
    // paddingRight: '16px',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0',
      marginTop: '8px',
      flexDirection: 'column',
      width: '100%',
      marginBottom: 33
    }
  },

  buttonWrapper: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },

    width: 'max-content',
    display: 'flex',
    padding: '8px 16px 8px 12px',
    gap: '8px'
  },

  buttonOutlined: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },

  check: {
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '16px'
    },
    '& input': {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: '1px',
      margin: '-1px',
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      width: '1px'
    },

    '& label': {
      position: 'relative',
      paddingLeft: '28px',
      display: 'inline-block',
      cursor: 'pointer',

      '&::before': {
        content: '""',
        border: `1px solid ${theme.app.colors.border.dark}`,
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '18px',
        width: '18px',
        background: '#FFF',
        marginRight: '0.5em',
        transition: 'all 0.2s ease',
        position: 'absolute',
        top: '50%',
        left: '0',
        transform: 'translate(0, -50%)',
        borderRadius: '3px'
      },

      '&::after': {
        content: '""',
        position: 'absolute',
        background: 'no-repeat center center',
        backgroundImage: `url(${checkImage})`,
        top: '50%',
        left: '0.65em',
        transform: 'translate(-50%, -50%)',
        color: '#FFF',
        opacity: '0',
        transition: 'all 0.2s ease',
        width: '18px',
        height: '18px'
      }
    },

    '& input:checked + label::after': {
      opacity: '1'
    },

    '& input:checked + label::before': {
      backgroundColor: theme.app.colors.border.dark
    }
  },

  formField: {},

  formTitle: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    borderBottom: `1px solid ${theme.app.colors.border.light}`,
    fontSize: '18px',
    width: '100%',
    padding: '0 0 8px',
    marginBottom: '16px',
    marginTop: '-16px'
  },

  checkControl: {
    display: 'flex',
    gap: 40,
    marginBottom: 16,

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
      gap: 10
    }
  },

  containerInput: {
    display: 'flex',
    gap: '20px',

    '& .halfWidth': {
      width: '100%'
    },

    '& input[type="search"]': {
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'calc(100% - 16px) center',
      backgroundImage: `url(${searchImage})`
    }
  },

  formFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',

    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0',
      marginTop: '8px',
      marginBottom: '16px',
      flexDirection: 'column',
      width: '100%'
    }
  }
}))
